/* eslint-disable */
import { Injectable } from '@angular/core';
import * as $ from 'jquery';

interface EloquaLoyaltyModel {
  elqFormName: string; // 'AmadeusFirstEloquaForm'
  elqSiteID: string; // "487768300"
  elqCustomerGUID: string; // ""
  elqCookieWrite: string; // "0"
  EmailAddress: string;
  dynamicOrganization: string; // ACO name
  MembershipID: number | string; // agent number
  IsExistingAmadeusFirstUser?: boolean; // in enroll - true, if login - false
}

@Injectable({
  providedIn: 'root'
})
export class EloquaLoyaltyService {
  loyaltyConfig = {
    elqFormName: 'AmadeusFirstEloquaForm',
    elqSiteID: '266319173',
    elqCustomerGUID: '',
    elqCookieWrite: '0'
  };

  getLoyaltyEloquaData(
    eloquaInfo: { EmailAddress: string; dynamicOrganization: string },
    MembershipID: number | string,
    IsExistingAmadeusFirstUser: boolean
  ): EloquaLoyaltyModel {
    return {
      ...this.loyaltyConfig,
      ...eloquaInfo,
      IsExistingAmadeusFirstUser,
      MembershipID
    };
  }

  postLoyaltyEloqua(data: EloquaLoyaltyModel) {
    // ONLY FOR ELOQUA REASON!

    $.ajax({
      url: 'https://s266319173.t.eloqua.com/e/f2',
      type: 'POST',
      data,
      dataType: 'text/html',
      contentType: 'application/x-www-form-urlencoded; charset=utf-8',
      success(success) {
        console.warn('eloqua success: ', success);
      },
      error(error) {
        console.warn('eloqua error: ', error);
      }
    });
  }
}
